import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const CTA = () => {
  return (
    <section className="py-32 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black to-zinc-950 z-0" />
      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-4xl md:text-6xl font-bold tracking-tighter mb-6">
            Ready to Architect the Future?
          </h2>
          <p className="text-xl text-zinc-400 mb-10 font-light max-w-2xl mx-auto">
            Partner with us to build sophisticated, AI-native software systems that drive your enterprise forward.
          </p>
          <button className="bg-cyan-500 text-black px-10 py-5 rounded-full font-bold text-lg hover:bg-cyan-400 transition-all hover:scale-105 duration-300 flex items-center justify-center gap-3 mx-auto active:scale-95">
            Initiate Technical Dialogue <SafeIcon icon={FiIcons.FiArrowRight} />
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;